export var EventStatusEnum;
(function (EventStatusEnum) {
    EventStatusEnum[EventStatusEnum["Tentative"] = 0] = "Tentative";
    EventStatusEnum[EventStatusEnum["Scheduled"] = 1] = "Scheduled";
    EventStatusEnum[EventStatusEnum["InProgress"] = 2] = "InProgress";
    EventStatusEnum[EventStatusEnum["Completed"] = 3] = "Completed";
    EventStatusEnum[EventStatusEnum["Cancelled"] = 4] = "Cancelled";
    EventStatusEnum[EventStatusEnum["Postponed"] = 5] = "Postponed";
    EventStatusEnum[EventStatusEnum["OnHold"] = 6] = "OnHold";
    EventStatusEnum[EventStatusEnum["Archived"] = 7] = "Archived";
    EventStatusEnum[EventStatusEnum["Registered"] = 8] = "Registered";
    EventStatusEnum[EventStatusEnum["Invited"] = 9] = "Invited";
})(EventStatusEnum || (EventStatusEnum = {}));
export var InvitationStatusEnum;
(function (InvitationStatusEnum) {
    InvitationStatusEnum[InvitationStatusEnum["Pending"] = 1] = "Pending";
    InvitationStatusEnum[InvitationStatusEnum["InProgress"] = 2] = "InProgress";
    InvitationStatusEnum[InvitationStatusEnum["Registered"] = 3] = "Registered";
    InvitationStatusEnum[InvitationStatusEnum["Invited"] = 4] = "Invited";
    InvitationStatusEnum[InvitationStatusEnum["Expired"] = 5] = "Expired";
    InvitationStatusEnum[InvitationStatusEnum["Declined"] = 6] = "Declined";
    InvitationStatusEnum[InvitationStatusEnum["NotComing"] = 7] = "NotComing";
    InvitationStatusEnum[InvitationStatusEnum["Waitlisted"] = 8] = "Waitlisted";
})(InvitationStatusEnum || (InvitationStatusEnum = {}));
export const F1EventStatusEnumDisplay = {
    [InvitationStatusEnum.Pending]: 'Pending',
    [InvitationStatusEnum.InProgress]: 'In Progress',
    [InvitationStatusEnum.Registered]: 'Registered',
    [InvitationStatusEnum.Invited]: 'Invited',
    [InvitationStatusEnum.Expired]: 'Expired',
    [InvitationStatusEnum.Declined]: 'Declined',
    [InvitationStatusEnum.NotComing]: 'Not coming'
};
export const EventStatusEnumDisplay = {
    [EventStatusEnum.Tentative]: 'Tentative',
    [EventStatusEnum.Scheduled]: 'Scheduled',
    [EventStatusEnum.InProgress]: 'In Progress',
    [EventStatusEnum.Completed]: 'Completed',
    [EventStatusEnum.Cancelled]: 'Cancelled',
    [EventStatusEnum.Postponed]: 'Postponed',
    [EventStatusEnum.OnHold]: 'On Hold',
    [EventStatusEnum.Archived]: 'Archived',
    [EventStatusEnum.Registered]: 'Registered',
    [EventStatusEnum.Invited]: 'Invited'
};
